<template>
  <div class="support">
    <div class="support-inventory-banner">
      <h2>Online Eğitimler</h2>
      <BannerSlider
        :itemsLength="supportData?.bannerInventoryDtos?.length ?? 0"
        :slideDelay="5000"
      >
        <template v-slot:content="{ currentIndex }">
          <BannerSliderItem
            v-for="(item, index) in supportData?.bannerInventoryDtos"
            :key="index"
            v-show="currentIndex === index"
            :item="item"
            @click="blankUrl(item.url)"
            class="supportSlider"
          >
            <img
              :src="item.imageUrl"
              class="supportSlider__image"
              style="width: 100%; height: auto"
            />
            <h2 class="supportSlider__header">{{ item.name }}</h2>
          </BannerSliderItem>
        </template>
      </BannerSlider>
    </div>
    <div class="support-inventory-html">
      <h2>En Çok Okunan İçerikler</h2>
      <div class="support-inventory-html-wrapper">
        <div
          class="support-inventory-html-item"
          v-for="(item, index) in supportData?.htmlInventoryDtos"
          :key="index"
          v-html="item.htmlContent"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { BannerSlider, BannerSliderItem } from '@n11/so-ui-components';

export default {
  name: 'ShopSupportCard',
  components: {
    BannerSlider,
    BannerSliderItem,
  },
  props: {
    supportData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    blankUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.support {
  display: flex;
  justify-content: center;
  &-inventory {
    &-banner {
      width: 50%;
      margin-right: 20px;
      h2 {
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.43;
        color: $dark-gray-5;
      }
      .supportSlider {
        margin-bottom: 17px;
        &__image {
          width: 100%;
          height: auto;
          max-height: 220px;
          border-radius: 8px;
          cursor: pointer;
        }
        &__header {
          position: absolute;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.25;
          left: 16px;
          bottom: 20px;
          color: $colorN00;
        }
      }
    }

    &-html {
      width: 50%;
      h2 {
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.43;
        color: $dark-gray-5;
      }
      &-wrapper {
        height: auto;
        max-height: 270px;
        overflow-y: auto;
        width: 100%;
      }
      &-item {
        display: flex;
        flex-direction: row;
        margin-bottom: 32px;
        &:deep(a) {
          display: flex;
          flex-direction: row;
          & img {
            width: 110px;
            height: 62px;
            border-radius: 6px;
            margin-right: 16px;
          }
          & div {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            & :nth-child(1) {
              color: $dark-gray-8;
              line-height: 1.43;
              font-size: 14px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              max-width: 324px;
            }
            & :nth-child(2) {
              color: $dark-gray-6;
              line-height: 1.43;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 415px) {
  .support {
    flex-direction: column;
    align-items: center;
  }
  .support-inventory-banner {
    width: 100%;
    margin: 0;
  }
  .support-inventory-html {
    width: 95%;
  }
}
</style>
